import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/appLogo.png';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Divider from './common/Divider';
import { message } from '../messages/Message';
import { useDispatch, useSelector } from 'react-redux';
import { forgetPassword } from '../services/operations/authAPI';
import Loader from '../Loader/Loader'

const schema = yup.object().shape({
  email: yup
    .string()
    .email(message.invalidEmailMessage)
    .required(message.emailRequiredMessage)
    .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/, message.invalidEmailMessage),
});

const ForgetPassword = () => {
  const { register, handleSubmit, watch, trigger, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    mode: 'onSubmit',  
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isValidEmail, setIsValidEmail] = useState(false);
  const loading=useSelector((state)=>state.auth.loading)

  const emailValue = watch('email');

  const onSubmit = async (data) => {
    const { email } = data;
    const payload = { email };
    await dispatch(forgetPassword(payload));
  };

  const handleButtonClick = async () => {
    const isValid = await trigger('email'); 
    setIsValidEmail(isValid);
  };

  return (
    <div className='login-page'>
      {loading && <Loader/>}
      <div className='login-header'>
        <img src={logo} alt='app-logo-login' style={{ cursor: "pointer" }} onClick={() => navigate('/')} />
        <p className="login-header-desc">
          To request a new password, please enter the email address of your 1800hired account.
        </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="login-form">
        <div className="login-form-group">
          <label htmlFor="email" className="form-label">Enter your email</label>
          <input
            type="text"
            id="email"
            placeholder='Enter your email'
            className={`form-input-login ${errors.email ? "input-error" : ""}`}
            {...register('email')}
          />
          {errors.email && <p className="error-message">{errors.email.message}</p>}
        </div>
        <button
          type="submit"
          className={`button-theme ${emailValue ? "button-enabled" : "button-disabled"}`}
          disabled={!emailValue}
          onClick={handleButtonClick} 
        >
          Continue
        </button>
      </form>
      
      <br />
      <Divider />
      <p>Already have an account?&nbsp;
        <span style={{ color: "rgba(45, 118, 253, 1)", fontWeight: "700", cursor: "pointer" }} onClick={() => navigate("/login")}>
          Sign in
        </span>
      </p>
    </div>
  );
}

export default ForgetPassword;
